
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11741',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11741",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.279",
  "data-fetching-client": "static-1.9537",
  "foundations-components": "static-1.7636",
  "foundations-components-legacy": "static-1.661",
  "foundations-theming": "static-1.4271",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7867",
  "hub-http-shared-msw-handlers": "static-1.9621",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11303",
  "I18n": "static-7.1590",
  "jasmine-runner": "static-1.6330",
  "marketplace-storefront-base": "static-1.11801",
  "quartz": "static-1.6811",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16510",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2723",
  "reporting-testing-lib": "static-1.8707",
  "settings-ui-lib": "static-1.12383",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6854",
  "ui-addon-i18n": "static-1.11004",
  "ui-addon-react-router-dom": "static-1.9405",
  "unified-auth": "static-1.296",
  "unified-auth-core-lib": "static-1.577",
  "usage-tracker": "static-1.7195",
  "usage-tracker-core": "static-1.7045",
  "customer-data-property-utils": "static-1.7940",
  "history": "static-4.47",
  "hub-http": "static-1.6077",
  "integrations-lib": "static-1.15614",
  "marketplace-ui-common": "static-1.19121",
  "property-management-iframe": "static-1.12602",
  "quartz-config": "static-1.589",
  "quartz-core": "static-1.6030",
  "quartz-routing": "static-1.241",
  "quick-fetch": "static-1.3794",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4502",
  "ts-schema": "static-1.3961",
  "ui-universal-auth": "static-1.8782",
  "UIComponents": "static-3.8250",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3286",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3088",
  "quartz-webpack": "static-1.3035",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3905",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4701",
  "foundations-theming-specialty": "static-1.1987",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9286",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5231",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1372",
  "ui-fonts": "static-1.565",
  "ui-images": "static-2.1115",
  "bend-plugin-foundations-theming": "static-1.2754",
  "foundations-theming-base": "static-1.3256",
  "stylex": "static-1.28",
  "HeadJS": "static-2.725",
  "hs-test-utils-bend-plugin": "static-1.2978",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4186",
  "ai-components-ui-library": "static-1.8530",
  "ai-rendering-library": "static-1.9495",
  "chirp-fetch": "static-1.1743",
  "connections-embed-lib": "static-1.721",
  "copilot-toolkit": "static-1.10689",
  "laboratory-lib": "static-3.7019",
  "marketplace-embed": "static-1.21633",
  "marketplace-ui-details": "static-1.9017",
  "marketplace-ui-reviews": "static-1.19077",
  "marketplace-ui-tracking": "static-1.13292",
  "sanitize-text": "static-1.8005",
  "ui-addon-video-player": "static-1.8556",
  "usage-tracker-multi": "static-1.5609",
  "usage-tracker-session-replay": "static-1.4881",
  "wootric-nps": "static-1.6842",
  "apollo-link-hub-http": "static-2.4511",
  "immer": "static-1.33",
  "immerable": "static-1.4014",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2404",
  "reporting-data": "static-1.66774",
  "cssUtils": "static-1.755",
  "flux-actions": "static-1.318",
  "HubStyle": "static-2.11611",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10071",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10234",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7185",
  "icons": "static-2.632",
  "marketplace-ui-apps-core": "static-1.17654",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4380",
  "foundations-components-test-utils": "static-1.5119",
  "quartz-i18n": "static-1.486",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3590",
  "customer-data-objects": "static-1.7512",
  "property-translator": "static-1.5270",
  "frontend-preferences-client": "static-1.7784",
  "hs-promise-utils": "static-1.5453",
  "hubspot-apollo-client": "static-1.4739",
  "integrations-error-boundary-lib": "static-1.13029",
  "integrations-tracking-lib": "static-1.5450",
  "native-integrations-shared-strings": "static-1.7647",
  "reselect": "static-2.16",
  "sanitize": "static-1.4334",
  "superstore": "static-1.4629",
  "ui-shepherd-react": "static-3.10006",
  "ai-settings-ui-library": "static-1.7641",
  "hub-http-janus": "static-1.810",
  "hubspotter-http": "static-1.4534",
  "immutable-less": "static-1.4514",
  "marketplace-ui-client-types": "static-1.16528",
  "nav-meta": "static-1.29099",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10102",
  "ui-addon-upgrades": "static-9.17745",
  "inbound-db-properties-service-client": "static-1.3727",
  "property-management-common": "static-1.4889",
  "ui-addon-iframeable": "static-1.8907",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.500",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.486",
  "quartz-head": "static-1.476",
  "quartz-test": "static-1.486",
  "quartz-tracking": "static-1.190",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3014",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20577",
  "ContentUtils": "static-1.67806",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2352",
  "customer-data-filters-ui": "static-1.39121",
  "customer-data-objects-ui-components": "static-1.12872",
  "customer-data-reference-ui-components": "static-1.13008",
  "embedded-academy-lib": "static-1.13765",
  "ExportDialog": "static-6.10247",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40812",
  "reporting-snowflake": "static-1.55392",
  "reporting-ui-components": "static-2.64045",
  "reporting-visualizations": "static-1.58850",
  "ui-addon-teams": "static-1.21325",
  "magpie-lib": "static-1.5454",
  "magpie-types": "static-1.4914",
  "simple-logging-lib": "static-1.2910",
  "navigation-components": "static-1.17462",
  "ai-studio-lib": "static-1.11163",
  "app-governance-lib": "static-1.1063",
  "developer-experience-shared-components": "static-1.10360",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7851",
  "ui-product-approvals": "static-1.27635",
  "ui-tool-access": "static-1.10005",
  "usage-based-billing-components-lib": "static-1.8176",
  "usage-tracker-anonymous": "static-1.5612",
  "usage-tracker-public": "static-1.7006",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3476",
  "persist-promise": "static-1.3568",
  "reference-resolvers": "static-1.8024",
  "ui-extensibility-client-types": "static-1.3801",
  "hubspot-apollo-cache": "static-1.198",
  "universal-page-editor-lib": "static-1.2861",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2345",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4930",
  "purchase-motions-components": "static-1.5573",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1411",
  "crm-component-utils": "static-1.38629",
  "crm-properties-common-lib": "static-1.5733",
  "customer-data-properties": "static-1.50973",
  "framework-data-schema-resolvers": "static-1.6733",
  "property-value-citations": "static-1.1587",
  "reference-resolvers-lite": "static-1.7945",
  "navigation-messaging": "static-1.6789",
  "hubspotter-http-shared-msw-handlers": "static-1.9619",
  "cms-field-types": "static-1.4669",
  "content-icons-ui": "static-1.2179",
  "conversations-skeleton-state": "static-1.7108",
  "crm-message-bus": "static-1.42547",
  "customer-data-filters-ui-msw-helpers": "static-1.21556",
  "customer-data-ui-utilities": "static-1.9684",
  "FormUrlGenerator": "static-2.4581",
  "framework-builder-read-service-client": "static-1.3889",
  "framework-data-schema-quick-fetch": "static-1.6638",
  "multi-account-reference-resolvers": "static-1.836",
  "onboarding-tours": "static-1.16346",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13230",
  "academy-common-lib": "static-1.13225",
  "content-assistance-lib": "static-1.7532",
  "dashboard-lib": "static-1.80872",
  "file-manager-components": "static-1.23092",
  "getting-started-shared-tasks": "static-1.18048",
  "hubspot-prosemirror": "static-1.17773",
  "hubspot-prosemirror-plugins": "static-1.17765",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19576",
  "share-with-third-party-component-lib": "static-1.8553",
  "ui-addon-draggable": "static-3.4628",
  "ui-asset-management-lib": "static-1.10793",
  "ui-business-units-lib": "static-1.8892",
  "user-context": "static-1.4960",
  "growth-payments-core": "static-1.24896",
  "reporting-plugins": "static-1.10053",
  "reporting-reports": "static-1.66452",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.585",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28987",
  "react-codemirror": "static-1.10486",
  "framework-listing-lib": "static-2-rr-react-compiler.25",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30253",
  "apps-service-types": "static-1.3737",
  "oauth-service-types": "static-1.4107",
  "onboarding-scopes": "static-1.6323",
  "onboarding-tours-client": "static-1.4560",
  "platform-infra-nav-components": "static-1.7548",
  "subscription-experience-data-types": "static-1.14662",
  "crm-record-cards-service-types": "static-1.3498",
  "location-customization-utils-lib": "static-1.8753",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4359",
  "nav-client-types": "static-1.2217",
  "purchase-motions-api": "static-1.5576",
  "signup-constants": "static-1.18518",
  "signup-ui-url-generator": "static-2.7894",
  "trials-service-types": "static-1.3760",
  "card-properties-lib": "static-1.43695",
  "commerce-subscription-lib": "static-1.36630",
  "crm-actions": "static-1.6168",
  "crm-cards-sdk": "static-1.43098",
  "customer-data-properties-shared-msw-handlers": "static-1.8948",
  "customer-data-tracking": "static-1.6742",
  "hs-entities": "static-1.546",
  "pulse": "static-1.383",
  "calling-global-api": "static-1.63912",
  "calling-internal-common": "static-1.31159",
  "calling-lifecycle-internal": "static-1.65294",
  "calling-lifecycle-messages": "static-1.57588",
  "commerce-products-lib": "static-1.9015",
  "conditional-properties-service-client": "static-1.3679",
  "crm-links": "static-1.6128",
  "external-options-client-types": "static-1.4040",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4104",
  "meetings-icalendar-utils-lib": "static-1.492",
  "multi-currency-client-types": "static-1.3571",
  "object-builder-ui-client": "static-1.48194",
  "pipeline-validation-client-types": "static-1.3845",
  "smart-property-lib": "static-1.6166",
  "tiered-pricing": "static-1.922",
  "ui-addon-form-validation": "static-1.10853",
  "crm-pipelines-api-client-types": "static-1.4021",
  "customer-data-associations": "static-1.7182",
  "customer-data-views-management": "static-1.25110",
  "framework-data-table": "static-2.11561",
  "marketing-platform-lib": "static-1.6704",
  "nudge-client-utils": "static-1.2275",
  "nudge-custom-ui-functions": "static-1.781",
  "react-dnd-compat": "static-1.4480",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5219",
  "growth-onboarding-confetti": "static-1.2932",
  "growth-onboarding-next-action-utils": "static-1.1454",
  "onboarding-tours-utils": "static-1.412",
  "ui-shepherd-tracker": "static-1.7387",
  "academy-service-client": "static-1.3540",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28103",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8243",
  "video-components-external": "static-1.10763",
  "video-data-lib": "static-1.34421",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8418",
  "payment-link-components": "static-1.23096",
  "ui-addon-emoji-picker": "static-1.9747",
  "EmailSignatureEditor": "static-1.24015",
  "viral-links-lib": "static-1.6898",
  "data-token-picker": "static-1.16148",
  "FileManagerLib": "static-1.38732",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5104",
  "getting-started-shared-tasks-store": "static-1.17166",
  "campaign-roi-lib": "static-1.8459",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "app-users-service-client": "static-1.5401",
  "app-users-service-types": "static-1.4809",
  "mini-checkout-client": "static-1.26468",
  "onboarding-utils": "static-1.5212",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28088",
  "edison-service-client-types": "static-1.252",
  "eligibility-engine-service-types": "static-1.3041",
  "crm_data": "static-4.91445",
  "customer-data-sidebar": "static-2.45577",
  "enrichment-properties-lib": "static-1.15284",
  "commerce-billing-lib": "static-1.18656",
  "commerce-shared-components-lib": "static-1.18113",
  "commerce-tools-ui-lib": "static-1.9948",
  "crm-fe-perf": "static-1.22764",
  "directed-graph": "static-1.799",
  "event-emitter": "static-1.807",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31165",
  "shared-worker-versioning": "static-1.10899",
  "calling-usage-tracker": "static-1.6401",
  "voice-sms-access-library": "static-1.421",
  "commerce-permissions": "static-1.623",
  "products-iframe-lib": "static-1.7494",
  "products-ui-components-shared-msw-handlers": "static-1.10003",
  "breeze-intelligence-kit": "static-1.5406",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9704",
  "policy-lib": "static-1.6638",
  "react-tinymce": "static-1.54791",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9767",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53917",
  "tinymce-plugins": "static-1.57031",
  "tinymce-themes": "static-1.55887",
  "crm-export-dialog": "static-1.6152",
  "crm-index-associations-lib": "static-1.6295",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1477",
  "tanstack-virtual": "static-1.26",
  "nudge-custom-function-registry": "static-1.2032",
  "nudge-renderer-utils": "static-1.2351",
  "whisper-core-api": "static-1.6157",
  "InboxConnectUtils": "static-4.14380",
  "growth-onboarding-next-action-components": "static-1.1482",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6441",
  "content-media-composition-data-lib": "static-1.11692",
  "content-media-compositions": "static-2.15699",
  "media-bridge-lib": "static-1.18670",
  "commerce-tours-lib": "static-1.5812",
  "growth-onboarding-reliability": "static-1.4946",
  "sales-checkout-service-client": "static-1.3528",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21414",
  "sales-email-signature-service-client": "static-1.3703",
  "audio-components": "static-1.5696",
  "FileManagerCore": "static-1.38591",
  "FileManagerImages": "static-1.36243",
  "video-components": "static-1.12766",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5206",
  "settings-content-modals": "static-1.45632",
  "crm_universal": "static-1.21750",
  "customer-data-email": "static-1.17775",
  "card-payment-highlight-lib": "static-1.36684",
  "card-subscription-highlight-lib": "static-1.39053",
  "commerce-contract-lib": "static-1.11417",
  "customer-data-content": "static-1.26987",
  "invoices-highlight-card-lib": "static-1.54221",
  "orders-highlight-card-lib": "static-1.21024",
  "products-highlight-card-lib": "static-1.17299",
  "project-storage": "static-1.4593",
  "quotes-highlight-card-lib": "static-1.71396",
  "crm-source-interpretation-lib": "static-1.5191",
  "utility-belt": "static-1.2400",
  "payments-enrollment-embed-lib": "static-1.22179",
  "customer-data-rte": "static-1.32591",
  "cv-backend-services": "static-1.1522",
  "growth-onboarding-empty-states": "static-1.5452",
  "payments-post-enroll-local-storage-lib": "static-1.4974",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37486",
  "calling-orchestration-schema": "static-1.35198",
  "sales-views-client-types": "static-1.4135",
  "hub-http-contrib": "static-1.2903",
  "interframe": "static-3.4622",
  "tinymce-data": "static-1.40002",
  "ui-addon-sales-email": "static-1.5073",
  "layout-dnd-components": "static-1.12157",
  "layout-dnd-utils": "static-1.11132",
  "ui-brand-identity-lib": "static-1.14308",
  "NamespacedHubStyle": "static-2.8951",
  "deal-intel-utils": "static-1.1481",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4391",
  "video-embed": "static-1.35255",
  "social-insights-client-types": "static-1.21555",
  "checkout-sdk": "static-3.23311",
  "checkout-service-types": "static-1.3715",
  "company-details-components": "static-1.6044",
  "payment-method-components": "static-1.6751",
  "pricing-pages-ui-components": "static-1.12941",
  "quote-checkout-service-types": "static-1.3346",
  "upgrade-catalog-service-types": "static-1.3386",
  "access-control-lib": "static-1.10298",
  "EmailComponents": "static-1.54308",
  "EmailData": "static-1.52985",
  "redux-less": "static-2.9346",
  "sequences-lib": "static-1.7788",
  "ui-gdpr-components": "static-1.10208",
  "products-ui-components": "static-1.39534",
  "quotes-ui-lib": "static-1.80117",
  "SalesContentIndexUI": "static-3.8995",
  "accounting-integrations-ui-components": "static-1.6825",
  "invoices-ui-lib": "static-1.54237",
  "commerce-products-api": "static-1.2047",
  "SafeStorage": "static-1.4262",
  "invoices-iframe-lib": "static-1.56295",
  "quotes-modal-lib": "static-1.102074",
  "stripe-embedded-components": "static-1.7244",
  "draft-content-plugins": "static-1.27859",
  "ContentData": "static-1.67881",
  "layout-data-lib": "static-1.9457",
  "outpost": "static-1.4060",
  "hub-http-rxjs": "static-1.776",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3789",
  "billing-payments-client-types": "static-1.3849",
  "account-and-billing-fintech-outages": "static-3.18316",
  "pricing-pages-api": "static-1.12806",
  "ContentComponents": "static-2.70762",
  "marketing-contacts-lib": "static-1.9320",
  "marketing-email-service-types": "static-1.1809",
  "messaging-editing-lib": "static-1.45794",
  "messaging-usage-based-billing-components-lib": "static-1.656",
  "automation-ui-source-apps": "static-1.18395",
  "automation-ui-types": "static-1.19313",
  "messaging-types-lib": "static-1.45531",
  "onboarding-settings-client": "static-1.4365",
  "sequences-client-types-lib": "static-1.7645",
  "commerce-tax-lib": "static-1.378",
  "property-description-translator": "static-1.3716",
  "FireAlarmUi": "static-1.4389",
  "sales-templates-service-types-lib": "static-1.4048",
  "commerce-analytics-service-client": "static-1.3516",
  "totals-ui-components": "static-1.23148",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14902",
  "advanced-menus-lib": "static-1.11870",
  "ui-memberships-settings-lib": "static-1.33609",
  "demographics-service-types": "static-1.1509",
  "automation-ui-ubb": "static-1.5229",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7200",
  "data-token-views": "static-1.16129",
  "forms-utils-lib": "static-1.12286",
  "payments-embed-points-lib": "static-1.12720",
  "simple-menus-core": "static-1.14901",
  "simple-menus-lib": "static-1.16418",
  "ui-addon-draggable-compat": "static-2.4114",
  "videoconference-integration-components": "static-1.6613",
  "automation-applications-service-types": "static-1.3393",
  "automation-platform-service-types": "static-1.2543",
  "ContentEditorUI": "static-2.76704",
  "short-messages-app-service-client": "static-1.3865",
  "web-interactives-components": "static-1.13505",
  "web-interactives-data": "static-1.13506",
  "messaging-shared-utils-lib": "static-1.105",
  "messaging-user-info-utils-lib": "static-1.275",
  "email-portal-health-service-types": "static-1.836",
  "commerce-totals-service-types": "static-1.3697",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21249",
  "automation-ui-usage-tracking": "static-1.20712",
  "data-studio-ubb": "static-1.2274",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26582",
  "collaboration-sidebar": "static-1.57292",
  "content-management-data-lib": "static-1.5186",
  "copilot-plugins": "static-1.10662",
  "cta-picker": "static-1.35993",
  "customer-agent-discovery-components-lib": "static-1.2608",
  "editor-components": "static-1.13019",
  "editor-iframe-lib": "static-1.8200",
  "error-messaging-js": "static-1.5050",
  "FormsCommonComponents": "static-1.85438",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.61",
  "redux-request-state": "static-1.10506",
  "SharedLegalStrings": "static-1.1612",
  "smart-content-core": "static-1.42014",
  "smart-content-lib": "static-1.42667",
  "social-composer-lib": "static-1.58377",
  "structured-content-lib": "static-1.24773",
  "theme-previewer-lib": "static-1.52842",
  "tinymce-copilot": "static-1.15985",
  "xray-recommendation-lib": "static-1.7673",
  "automation-ui-routing": "static-1.20670",
  "sql-reporting-client-types": "static-1.5526",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41801",
  "campaigns-utils-lib": "static-1.3015",
  "reporting-enablement": "static-1.22296",
  "chatspot-widget-iframe": "static-1.20569",
  "collaboration-sidebar-common": "static-1.2089",
  "forms-ai-lib": "static-1.4092",
  "codemirror-dlb": "static-1.58263",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6287",
  "report-customization-components": "static-1.12686",
  "data-quality-ui-library": "static-1.12470",
  "html-to-image": "static-1.50",
  "reporting-insights-lib": "static-1.1245"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11741",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.279",
  "data-fetching-client": "/data-fetching-client/static-1.9537",
  "foundations-components": "/foundations-components/static-1.7636",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.661",
  "foundations-theming": "/foundations-theming/static-1.4271",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7867",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9621",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11303",
  "I18n": "/I18n/static-7.1590",
  "jasmine-runner": "/jasmine-runner/static-1.6330",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11801",
  "quartz": "/quartz/static-1.6811",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16510",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2723",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8707",
  "settings-ui-lib": "/settings-ui-lib/static-1.12383",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6854",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11004",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9405",
  "unified-auth": "/unified-auth/static-1.296",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.577",
  "usage-tracker": "/usage-tracker/static-1.7195",
  "usage-tracker-core": "/usage-tracker-core/static-1.7045",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7940",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6077",
  "integrations-lib": "/integrations-lib/static-1.15614",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19121",
  "property-management-iframe": "/property-management-iframe/static-1.12602",
  "quartz-config": "/quartz-config/static-1.589",
  "quartz-core": "/quartz-core/static-1.6030",
  "quartz-routing": "/quartz-routing/static-1.241",
  "quick-fetch": "/quick-fetch/static-1.3794",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4502",
  "ts-schema": "/ts-schema/static-1.3961",
  "ui-universal-auth": "/ui-universal-auth/static-1.8782",
  "UIComponents": "/UIComponents/static-3.8250",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3286",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3088",
  "quartz-webpack": "/quartz-webpack/static-1.3035",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3905",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4701",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1987",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9286",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5231",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1372",
  "ui-fonts": "/ui-fonts/static-1.565",
  "ui-images": "/ui-images/static-2.1115",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2754",
  "foundations-theming-base": "/foundations-theming-base/static-1.3256",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.725",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2978",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4186",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8530",
  "ai-rendering-library": "/ai-rendering-library/static-1.9495",
  "chirp-fetch": "/chirp-fetch/static-1.1743",
  "connections-embed-lib": "/connections-embed-lib/static-1.721",
  "copilot-toolkit": "/copilot-toolkit/static-1.10689",
  "laboratory-lib": "/laboratory-lib/static-3.7019",
  "marketplace-embed": "/marketplace-embed/static-1.21633",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9017",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19077",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13292",
  "sanitize-text": "/sanitize-text/static-1.8005",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8556",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5609",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4881",
  "wootric-nps": "/wootric-nps/static-1.6842",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4511",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4014",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2404",
  "reporting-data": "/reporting-data/static-1.66774",
  "cssUtils": "/cssUtils/static-1.755",
  "flux-actions": "/flux-actions/static-1.318",
  "HubStyle": "/HubStyle/static-2.11611",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10071",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10234",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7185",
  "icons": "/icons/static-2.632",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17654",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4380",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5119",
  "quartz-i18n": "/quartz-i18n/static-1.486",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3590",
  "customer-data-objects": "/customer-data-objects/static-1.7512",
  "property-translator": "/property-translator/static-1.5270",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7784",
  "hs-promise-utils": "/hs-promise-utils/static-1.5453",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4739",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13029",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5450",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7647",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4334",
  "superstore": "/superstore/static-1.4629",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10006",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7641",
  "hub-http-janus": "/hub-http-janus/static-1.810",
  "hubspotter-http": "/hubspotter-http/static-1.4534",
  "immutable-less": "/immutable-less/static-1.4514",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16528",
  "nav-meta": "/nav-meta/static-1.29099",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10102",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17745",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3727",
  "property-management-common": "/property-management-common/static-1.4889",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8907",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.500",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.486",
  "quartz-head": "/quartz-head/static-1.476",
  "quartz-test": "/quartz-test/static-1.486",
  "quartz-tracking": "/quartz-tracking/static-1.190",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3014",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20577",
  "ContentUtils": "/ContentUtils/static-1.67806",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2352",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39121",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12872",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13008",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13765",
  "ExportDialog": "/ExportDialog/static-6.10247",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40812",
  "reporting-snowflake": "/reporting-snowflake/static-1.55392",
  "reporting-ui-components": "/reporting-ui-components/static-2.64045",
  "reporting-visualizations": "/reporting-visualizations/static-1.58850",
  "ui-addon-teams": "/ui-addon-teams/static-1.21325",
  "magpie-lib": "/magpie-lib/static-1.5454",
  "magpie-types": "/magpie-types/static-1.4914",
  "simple-logging-lib": "/simple-logging-lib/static-1.2910",
  "navigation-components": "/navigation-components/static-1.17462",
  "ai-studio-lib": "/ai-studio-lib/static-1.11163",
  "app-governance-lib": "/app-governance-lib/static-1.1063",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10360",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7851",
  "ui-product-approvals": "/ui-product-approvals/static-1.27635",
  "ui-tool-access": "/ui-tool-access/static-1.10005",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8176",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5612",
  "usage-tracker-public": "/usage-tracker-public/static-1.7006",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3476",
  "persist-promise": "/persist-promise/static-1.3568",
  "reference-resolvers": "/reference-resolvers/static-1.8024",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3801",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.198",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2861",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2345",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4930",
  "purchase-motions-components": "/purchase-motions-components/static-1.5573",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1411",
  "crm-component-utils": "/crm-component-utils/static-1.38629",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5733",
  "customer-data-properties": "/customer-data-properties/static-1.50973",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6733",
  "property-value-citations": "/property-value-citations/static-1.1587",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7945",
  "navigation-messaging": "/navigation-messaging/static-1.6789",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9619",
  "cms-field-types": "/cms-field-types/static-1.4669",
  "content-icons-ui": "/content-icons-ui/static-1.2179",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7108",
  "crm-message-bus": "/crm-message-bus/static-1.42547",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21556",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9684",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4581",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3889",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6638",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.836",
  "onboarding-tours": "/onboarding-tours/static-1.16346",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13230",
  "academy-common-lib": "/academy-common-lib/static-1.13225",
  "content-assistance-lib": "/content-assistance-lib/static-1.7532",
  "dashboard-lib": "/dashboard-lib/static-1.80872",
  "file-manager-components": "/file-manager-components/static-1.23092",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18048",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17773",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17765",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19576",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8553",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4628",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10793",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8892",
  "user-context": "/user-context/static-1.4960",
  "growth-payments-core": "/growth-payments-core/static-1.24896",
  "reporting-plugins": "/reporting-plugins/static-1.10053",
  "reporting-reports": "/reporting-reports/static-1.66452",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.585",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28987",
  "react-codemirror": "/react-codemirror/static-1.10486",
  "framework-listing-lib": "/framework-listing-lib/static-2-rr-react-compiler.25",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30253",
  "apps-service-types": "/apps-service-types/static-1.3737",
  "oauth-service-types": "/oauth-service-types/static-1.4107",
  "onboarding-scopes": "/onboarding-scopes/static-1.6323",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4560",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7548",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14662",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3498",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8753",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4359",
  "nav-client-types": "/nav-client-types/static-1.2217",
  "purchase-motions-api": "/purchase-motions-api/static-1.5576",
  "signup-constants": "/signup-constants/static-1.18518",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7894",
  "trials-service-types": "/trials-service-types/static-1.3760",
  "card-properties-lib": "/card-properties-lib/static-1.43695",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36630",
  "crm-actions": "/crm-actions/static-1.6168",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43098",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8948",
  "customer-data-tracking": "/customer-data-tracking/static-1.6742",
  "hs-entities": "/hs-entities/static-1.546",
  "pulse": "/pulse/static-1.383",
  "calling-global-api": "/calling-global-api/static-1.63912",
  "calling-internal-common": "/calling-internal-common/static-1.31159",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65294",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57588",
  "commerce-products-lib": "/commerce-products-lib/static-1.9015",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3679",
  "crm-links": "/crm-links/static-1.6128",
  "external-options-client-types": "/external-options-client-types/static-1.4040",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4104",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.492",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3571",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48194",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3845",
  "smart-property-lib": "/smart-property-lib/static-1.6166",
  "tiered-pricing": "/tiered-pricing/static-1.922",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10853",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4021",
  "customer-data-associations": "/customer-data-associations/static-1.7182",
  "customer-data-views-management": "/customer-data-views-management/static-1.25110",
  "framework-data-table": "/framework-data-table/static-2.11561",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6704",
  "nudge-client-utils": "/nudge-client-utils/static-1.2275",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.781",
  "react-dnd-compat": "/react-dnd-compat/static-1.4480",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5219",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2932",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1454",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.412",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7387",
  "academy-service-client": "/academy-service-client/static-1.3540",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28103",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8243",
  "video-components-external": "/video-components-external/static-1.10763",
  "video-data-lib": "/video-data-lib/static-1.34421",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8418",
  "payment-link-components": "/payment-link-components/static-1.23096",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9747",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24015",
  "viral-links-lib": "/viral-links-lib/static-1.6898",
  "data-token-picker": "/data-token-picker/static-1.16148",
  "FileManagerLib": "/FileManagerLib/static-1.38732",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5104",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17166",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8459",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "app-users-service-client": "/app-users-service-client/static-1.5401",
  "app-users-service-types": "/app-users-service-types/static-1.4809",
  "mini-checkout-client": "/mini-checkout-client/static-1.26468",
  "onboarding-utils": "/onboarding-utils/static-1.5212",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28088",
  "edison-service-client-types": "/edison-service-client-types/static-1.252",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3041",
  "crm_data": "/crm_data/static-4.91445",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45577",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15284",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18656",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18113",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9948",
  "crm-fe-perf": "/crm-fe-perf/static-1.22764",
  "directed-graph": "/directed-graph/static-1.799",
  "event-emitter": "/event-emitter/static-1.807",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31165",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10899",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6401",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.421",
  "commerce-permissions": "/commerce-permissions/static-1.623",
  "products-iframe-lib": "/products-iframe-lib/static-1.7494",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10003",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5406",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9704",
  "policy-lib": "/policy-lib/static-1.6638",
  "react-tinymce": "/react-tinymce/static-1.54791",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9767",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53917",
  "tinymce-plugins": "/tinymce-plugins/static-1.57031",
  "tinymce-themes": "/tinymce-themes/static-1.55887",
  "crm-export-dialog": "/crm-export-dialog/static-1.6152",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6295",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1477",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2032",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2351",
  "whisper-core-api": "/whisper-core-api/static-1.6157",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14380",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1482",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6441",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11692",
  "content-media-compositions": "/content-media-compositions/static-2.15699",
  "media-bridge-lib": "/media-bridge-lib/static-1.18670",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5812",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4946",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3528",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21414",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3703",
  "audio-components": "/audio-components/static-1.5696",
  "FileManagerCore": "/FileManagerCore/static-1.38591",
  "FileManagerImages": "/FileManagerImages/static-1.36243",
  "video-components": "/video-components/static-1.12766",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5206",
  "settings-content-modals": "/settings-content-modals/static-1.45632",
  "crm_universal": "/crm_universal/static-1.21750",
  "customer-data-email": "/customer-data-email/static-1.17775",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36684",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39053",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11417",
  "customer-data-content": "/customer-data-content/static-1.26987",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54221",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21024",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17299",
  "project-storage": "/project-storage/static-1.4593",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71396",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5191",
  "utility-belt": "/utility-belt/static-1.2400",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22179",
  "customer-data-rte": "/customer-data-rte/static-1.32591",
  "cv-backend-services": "/cv-backend-services/static-1.1522",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5452",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4974",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37486",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35198",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "hub-http-contrib": "/hub-http-contrib/static-1.2903",
  "interframe": "/interframe/static-3.4622",
  "tinymce-data": "/tinymce-data/static-1.40002",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5073",
  "layout-dnd-components": "/layout-dnd-components/static-1.12157",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11132",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14308",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8951",
  "deal-intel-utils": "/deal-intel-utils/static-1.1481",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4391",
  "video-embed": "/video-embed/static-1.35255",
  "social-insights-client-types": "/social-insights-client-types/static-1.21555",
  "checkout-sdk": "/checkout-sdk/static-3.23311",
  "checkout-service-types": "/checkout-service-types/static-1.3715",
  "company-details-components": "/company-details-components/static-1.6044",
  "payment-method-components": "/payment-method-components/static-1.6751",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.12941",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3346",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3386",
  "access-control-lib": "/access-control-lib/static-1.10298",
  "EmailComponents": "/EmailComponents/static-1.54308",
  "EmailData": "/EmailData/static-1.52985",
  "redux-less": "/redux-less/static-2.9346",
  "sequences-lib": "/sequences-lib/static-1.7788",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10208",
  "products-ui-components": "/products-ui-components/static-1.39534",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80117",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8995",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6825",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54237",
  "commerce-products-api": "/commerce-products-api/static-1.2047",
  "SafeStorage": "/SafeStorage/static-1.4262",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56295",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102074",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7244",
  "draft-content-plugins": "/draft-content-plugins/static-1.27859",
  "ContentData": "/ContentData/static-1.67881",
  "layout-data-lib": "/layout-data-lib/static-1.9457",
  "outpost": "/outpost/static-1.4060",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.776",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3789",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3849",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18316",
  "pricing-pages-api": "/pricing-pages-api/static-1.12806",
  "ContentComponents": "/ContentComponents/static-2.70762",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9320",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1809",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45794",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.656",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18395",
  "automation-ui-types": "/automation-ui-types/static-1.19313",
  "messaging-types-lib": "/messaging-types-lib/static-1.45531",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4365",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7645",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.378",
  "property-description-translator": "/property-description-translator/static-1.3716",
  "FireAlarmUi": "/FireAlarmUi/static-1.4389",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4048",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3516",
  "totals-ui-components": "/totals-ui-components/static-1.23148",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14902",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11870",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33609",
  "demographics-service-types": "/demographics-service-types/static-1.1509",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5229",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7200",
  "data-token-views": "/data-token-views/static-1.16129",
  "forms-utils-lib": "/forms-utils-lib/static-1.12286",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12720",
  "simple-menus-core": "/simple-menus-core/static-1.14901",
  "simple-menus-lib": "/simple-menus-lib/static-1.16418",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4114",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6613",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3393",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2543",
  "ContentEditorUI": "/ContentEditorUI/static-2.76704",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3865",
  "web-interactives-components": "/web-interactives-components/static-1.13505",
  "web-interactives-data": "/web-interactives-data/static-1.13506",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.105",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.275",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.836",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3697",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21249",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20712",
  "data-studio-ubb": "/data-studio-ubb/static-1.2274",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26582",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57292",
  "content-management-data-lib": "/content-management-data-lib/static-1.5186",
  "copilot-plugins": "/copilot-plugins/static-1.10662",
  "cta-picker": "/cta-picker/static-1.35993",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2608",
  "editor-components": "/editor-components/static-1.13019",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8200",
  "error-messaging-js": "/error-messaging-js/static-1.5050",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85438",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.61",
  "redux-request-state": "/redux-request-state/static-1.10506",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1612",
  "smart-content-core": "/smart-content-core/static-1.42014",
  "smart-content-lib": "/smart-content-lib/static-1.42667",
  "social-composer-lib": "/social-composer-lib/static-1.58377",
  "structured-content-lib": "/structured-content-lib/static-1.24773",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52842",
  "tinymce-copilot": "/tinymce-copilot/static-1.15985",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7673",
  "automation-ui-routing": "/automation-ui-routing/static-1.20670",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5526",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41801",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3015",
  "reporting-enablement": "/reporting-enablement/static-1.22296",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20569",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2089",
  "forms-ai-lib": "/forms-ai-lib/static-1.4092",
  "codemirror-dlb": "/codemirror-dlb/static-1.58263",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6287",
  "report-customization-components": "/report-customization-components/static-1.12686",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12470",
  "html-to-image": "/html-to-image/static-1.50",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1245"
}
};
